var m = require('mithril');
var c3 = require('c3');
var d3 = require('d3');
var loaders = require('../../layout/components/loaders');
var Point = require('../../data/models/point');
var heading = require('../../components/heading');

var gaugeChart = {};

gaugeChart.oninit = function (vnode) {
  var ctrl = this;

  ctrl.element = vnode.attrs.element;
  ctrl.column = ctrl.element.out_Contains[0].in.out_Column[0];
  ctrl.series = [];

  var date = new Date();
  gaugeChart.hours = date.getHours();
  date.setHours(0);
  date.setMinutes(0);

  var q = "select mean(value) from point " +
    "where id = '" + ctrl.column.in['@rid'] + "' and " +
    "time < now() and time > " + date.valueOf() * 1000000 + " ; ";

  loaders.requestWithLoader({
    url: '/api/v1/data/query/',
    method: 'GET',
    params: {
      query: q
    },
  })
  .then(function (rows) {
    ctrl.series = rows;
  })

};

gaugeChart.config = function (ctrl) {
  return function(element, isInitialized, context) {
    if (!isInitialized) {
      var value = ctrl.series[ctrl.series.length -1].mean;
      ctrl.in.value = value;
      value = Point.readValue(ctrl.in);
      value = value * 60 * gaugeChart.hours;
      var chart = c3.generate({
        bindto: element,
        data: {
          columns: [
              ['data', value]
          ],
          type: 'gauge'
        },
        gauge: {
          label: {
            show: true,
            format: function (value, ratio) {
              return d3.format(',.3f')(value);
            }
          },
          expand: false,
          width: 10,
          max: ctrl.max || 500000,
          min: ctrl.min || 0,
          units: 'Gallons'
        }
      })
      ctrl.chart = chart;
    }
  }
}

var c3ParentContainerResizeFix = function (ctrl) {
  return function (element, isInitialized, context) {
    if (!isInitialized) {
      window.addEventListener('resize', function () {
        var size = { width: element.offsetWidth - 10 };
        ctrl.chart.resize(size);
      }, true);
    }
  }
}

gaugeChart.view = function() {
  var ctrl=this
  var columnRecord = ctrl.element.out_Contains[0].in.out_Column[0];
  columnRecord.series = ctrl.series;

  return m('div', {style: {minHeight: '24em'}}, [
    m(heading, {label: ctrl.element.name, class: 'fw2 f3 mb2 pb1', element: ctrl.element, parentReinitialize: ctrl.parentReinitialize}),
    m('div', {config: c3ParentContainerResizeFix(ctrl)}, [
      m('div', {config: gaugeChart.config(columnRecord)})
    ])
  ])
};


module.exports = gaugeChart;
